import {Enum} from 'enumify';

class TableComponentEnum extends Enum{}

     TableComponentEnum.initEnum({
         ROWCOLUMN: 'rowColumn',
         TABLEBODY: 'tableBody',
         TABLESEARCHHEADER: 'tableSearchHeader',
         TABLEHEAD: 'tableHead',
         TABLEPAGINATION : 'tablePagination'
        }
     );

export default TableComponentEnum;